<template>
  <div class="detail-section-container">
    <!-- 动态渲染每个 section -->
    <div
      v-for="(section, index) in sections"
      :key="index"
      :class="['section-item', { 'mb-4': index < sections.length - 1 }]"
    >
      <!-- 标题区域：优先使用插槽，否则使用默认 -->
      <div class="section-header">
        <slot
          :name="`title-${index}`"
          :section="section"
          :index="index"
        >
          <!-- 默认标题 -->
          <i :class="getIconClass(section.icon)" class="icon mr-2"></i>
          <h3 class="title">{{ section.title }}</h3>
        </slot>
      </div>

      <!-- 内容区域：优先使用插槽，否则使用默认 -->
      <div class="section-content">
        <slot
          :name="`content-${index}`"
          :section="section"
          :index="index"
        >
          <!-- 默认内容 -->
          <div v-if="section.type === 'text'" class="text-content" v-html="section.content"></div>

          <div v-else-if="section.type === 'image'">
            <img
              v-if="!section.customMediaComponent"
              :src="section.content"
              :alt="section.title"
              class="media-image"
            />
            <component
              v-else
              :is="section.customMediaComponent"
              :src="section.content"
              :title="section.title"
            ></component>
          </div>

          <div v-else-if="section.type === 'video'">
            <video
              v-if="!section.customMediaComponent"
              :src="section.content"
              controls
              class="media-video"
            ></video>
            <component
              v-else
              :is="section.customMediaComponent"
              :src="section.content"
              :title="section.title"
            ></component>
          </div>

          <div v-else-if="section.type === 'audio'">
            <audio
              v-if="!section.customMediaComponent"
              :src="section.content"
              controls
              class="media-audio"
            ></audio>
            <component
              v-else
              :is="section.customMediaComponent"
              :src="section.content"
              :title="section.title"
            ></component>
          </div>

          <ul v-else-if="section.type === 'list'" class="content-list">
            <li v-for="(item, idx) in section.content" :key="idx" v-html="item"></li>
          </ul>

          <!-- 可选：兜底提示 -->
          <div v-else class="text-muted">未识别的内容类型</div>
        </slot>
      </div>
    </div>

    <!-- 底部按钮组 -->
    <div v-if="buttons && buttons.length > 0" class="button-group mt-5">
      <el-button
        v-for="(btn, idx) in buttons"
        :key="idx"
        :type="btn.type || 'primary'"
        :plain="btn.plain"
        :disabled="btn.disabled"
        @click="btn.click"
      >
        {{ btn.text }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailSection',
  props: {
    sections: {
      type: Array,
      required: true,
      default: () => []
    },
    buttons: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getIconClass(iconName) {
      const iconMap = {
        info: 'el-icon-info',
        warning: 'el-icon-warning',
        question: 'el-icon-question',
        circle: 'el-icon-circle',
        lightbulb: 'el-icon-lightbulb'
      };
      return iconMap[iconName] || 'el-icon-info';
    }
  }
};
</script>

<style scoped>
/* 详情弹框样式优化 */
.detail-section-container {
  font-family: "Microsoft YaHei", "PingFang SC", -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 0;
  background-color: transparent;
}

.section-item {
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 0;
  background-color: transparent;
}

.section-item:not(:last-child) {
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.section-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  padding-bottom: 0;
  border-bottom: none;
}

.section-header .icon {
  font-size: 16px;
  color: #8b5cf6;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
}

.section-header .title {
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  margin: 0;
  margin-left: 0;
  line-height: 1.5;
}

.section-content {
  line-height: 1.6;
  color: #1e293b;
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
}

.text-content {
  white-space: pre-line;
  word-break: break-word;
}

.media-image,
.media-video,
.media-audio {
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.content-list {
  padding-left: 20px;
  list-style-type: disc;
  margin: 10px 0;
}

.content-list li {
  margin: 8px 0;
  line-height: 1.6;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .section-item {
    padding: 15px 0;
  }
  .section-header .title {
    font-size: 13px;
  }
  .section-content {
    font-size: 13px;
  }
}
</style>